<template>
<div v-if="initialization">
    <activityIndex v-if="templateId!='0'" :hotelCode="indexHotelCode" :templateId="templateId" :templateInfo="templateInfo"></activityIndex>
    <div class="index-ui" v-else>
        <van-pull-refresh v-model="isLoading" @refresh="refresh">
            <div class="swiper-container">
                <div class="search" @click="goSeacher">
                    <i class="iconfont iconsousuo"></i>
                    <p>搜索</p>
                </div>
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in slides.datas" :key="index">
                        <img :src="item+'?imageView2/1/w/750/h/500/q80/format/webp&x-oss-process=image/resize,m_fill,w_750,h_500'" @click="goPage(slides.link[index],index)" />
                    </div>
                </div>
                <div class="swiper-pagination"></div>

                <!-- <div class="search" @click="goSeacher">搜索</div> -->
            </div>
            <shopModule></shopModule>
            <div class="container container-box" v-if="coupons.length>0&&couponActivityConfig.isIndex=='T'">
                <div class="title">
                    <div class="tl">领券中心</div>
                    <div class="more" @click="goCouponCenter">
                        更多
                        <i class="iconfont icongengduo1"></i>
                    </div>
                </div>

                <div class="couponListBox">
                    <div class="couponListActivity" :class="{'couponListActivity-scroll':couponActivityConfig.showStyle=='2'}">
                        <div class="couponActivity" v-for="(coupon,couponIndex) in coupons" :key="couponIndex" v-if="couponIndex<couponActivityConfig.showLimit" @click.stop="goCouponInfo(coupon)">
                            <div class="couponActivityInner">
                                <div class="leftPart">
                                    <img :src="coupon.listPicture">
                                </div>
                                <div class="rightPart" @click.stop="chooseCoupon(coupon)">
                                    <p class="price">{{coupon.name}}</p>
                                    <p class="subTitle">{{coupon.secondName}}</p>
                                    <template v-if="user&&user.memberId">
                                        <template v-if="coupon.canReceived == 'T'">
                                            <a class="getBtn">{{coupon.buttonText}}</a>
                                        </template>
                                        <template v-else>
                                            <a class="getBtn disable">{{coupon.buttonText}}</a>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <a class="getBtn">{{coupon.buttonText}}</a>
                                    </template>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div class="flash-warp">
                <div class="flash-list" v-for="(item,i) in rushGoods" :key="i" v-if="item.length>0&&item[0].maxNum">
                    <div class="title">
                        <div class="tl">限时抢购</div>
                        <div class="more" @click="goShopFlashSale(item)">
                            更多
                            <i class="iconfont icongengduo1"></i>
                        </div>
                    </div>
                    <div class="goods-list-box" id="goodsList" v-if="item[0].showStyle=='2'">
                        <goodsListSmall :goodsListData="item" :number="item[0].maxNum" isBtn="F" goodsType="flash"></goodsListSmall>
                    
                    </div>
                    <div class="goods-list-box-two" v-else>
                        <goodsList class="goodsList" :goodsListData="item"  :number="item[0].maxNum" isBtn="F" goodsType="flash"></goodsList>
                    </div>
                </div>
            </div>
           
            <div class="flash-list" v-if="groupList.length > 0 &&groupActivityConfig.isIndex=='T'">
                <div class="title">
                    <div class="tl">爆款拼团</div>
                    <div class="more" @click="goGroupList">
                        拼团专区
                        <i class="iconfont icongengduo1"></i>
                    </div>
                </div>
                <div class="goods-list-box" id="groupList" v-if="groupActivityConfig.showStyle=='2'">
                    <goodsListSmall class="goodsList" :goodsListData="groupList" :number="groupActivityConfig.showLimit" goodsType="group"></goodsListSmall>
                </div>
                <div class="goods-list-box-two" v-else>
                    <goodsList class="goodsList" :goodsListData="groupList" :number="groupActivityConfig.showLimit" goodsType="group"></goodsList>
                </div>
            </div>

            <div class="bananer-adv">
                <bananerAdv :location="location"></bananerAdv>
            </div>
            <div class="container content-box" v-if="indexHotelGoods=='T'">
                <div class="option">
                    <div class="option-boxs">
                        <div class="option-box" @click="isShowLayer('city')" v-if="curChooseInfo.city==''||curChooseInfo.city=='all'">
                            <div class="option-box-top">
                                <i class="iconfont iconweizhi"></i>
                                <div class="choose" v-if="curChooseInfo.city==''">选择地区</div>
                                <div class="choose" v-else>{{curChooseInfo.cityDesc}}</div>
                            </div>
                            <div class="num">共<b>{{areaInfo.length-1}}</b>个城市</div>
                        </div>
                        <div class="option-box option-select" @click="isShowLayer('city')" v-else>
                            <i class="iconfont iconweizhi"></i>
                            <div class="choose">{{curChooseInfo.cityDesc}}</div>
                        </div>
                        <div class="option-box option-box-flex" @click="isShowLayer('hotel')" v-if="curChooseInfo.hotelCode==''||curChooseInfo.hotelCode=='all'">
                            <div class="option-box-top">
                                <i class="iconfont iconjiudianweixuanzhong"></i>
                                <div class="choose" v-if="curChooseInfo.hotelCode==''">选择酒店</div>
                                <div class="choose" v-else>{{curChooseInfo.hotelName}}</div>
                            </div>
                            <div class="num">共<b>{{hotelList.length-1}}</b>个酒店</div>
                        </div>
                        <div class="option-box option-select option-box-flex" @click="isShowLayer('hotel')" v-else>
                            <i class="iconfont iconjiudianweixuanzhong"></i>
                            <div class="choose">{{curChooseInfo.hotelName}}</div>
                        </div>
                    </div>
                    <div class="goods-num">
                        共计产品
                        <p><b>{{totalRows}}</b>款</p>
                    </div>

                </div>
                <div class="hotel_goods_list">
                    <goodsList class="goodsList" :goodsListData="goodsList"></goodsList>
                </div>

                <div class="more-goods">
                    <div class="btn" @click="goType()">点击查看更多 <i class="icongengduo1 iconfont"></i></div>
                </div>
                <!-- <div class="welcome">— 绿云提供运营和技术支持 —</div> -->
            </div>
            <div class="goodsListHot" v-else-if="this.goodsList.length > 0">
                <div class="title">
                    <div class="tl">热门推荐</div>
                    <div class="more" @click="goTypeList()">
                        更多
                        <i class="iconfont icongengduo1"></i>
                    </div>
                </div>

                <goodsList class="goodsList" :goodsListData="goodsList" goodsType="hot"></goodsList>
            </div>
            <div class="goodsTypes">
                <div class="goodsType" v-for="(item,i) in goodsType" v-if="item.goodsList.length>0&&item.number>0">
                    <div class="title">
                        <div class="tl">{{ item.typeName }}</div>
                        <div class="more" @click="getmore(item)">
                            更多
                            <i class="iconfont icongengduo1"></i>
                        </div>
                    </div>
                    <goodsList :goodsListData="item.goodsList" :number="item.number" isBtn="F" class="goodsListForType"></goodsList>
                    <div class="goodsTypeBg">
                        <img src="https://xcx.ihotel.cn/mall/images/goodsTypeBg.png" />
                    </div>
                </div>
            </div>

        </van-pull-refresh>
        <div class="group-tips" v-if="$route.query.belongHotelCode&&$route.query.belongHotelCode!=='0'">还不过瘾吗？ 去<b @click='goGroupHotel()'> 集团商城</b>看看吧~</div>
        <IPhoneBottomHeight></IPhoneBottomHeight>
        <bottomNav :icon="icon"></bottomNav>
    </div>
    <div class="choose-layer" :class="{'choose-layer-active':isLayer.isShowCity}">
        <div class="choose-layer-box">
            <div class="tl">— 请选择城市 —</div>
            <div class="list">
                <div class="item" v-for="(item,i) in areaInfo" :key="i" @click="chooseCity(item)" :class="{'active':curChooseInfo.city==item.code}">
                    <i class="iconfont iconweizhi"></i>{{item.descript}}
                    <i class="iconfont icongouhao"></i>
                </div>
            </div>
            <div class="btn" @click="closeLayer('city')">
                <div class="btn-box">确 定</div>
            </div>
        </div>
    </div>
    <div class="choose-layer" :class="{'choose-layer-active':isLayer.isShowHotel}">
        <div class="choose-layer-box">
            <div class="tl">— 请选择<b>{{curChooseInfo.cityDesc}}</b>门店 —</div>
            <div class="list">
                <div class="item big-item" v-for="(item,i) in hotelList" :key="i" @click="chooseHotel(item)" :class="{'active':curChooseInfo.hotelCode==item.code}">
                    <i class="iconfont iconjiudianweixuanzhong"></i>{{item.descript}}
                    <i class="iconfont icongouhao"></i>
                </div>
            </div>
            <div class="btn" @click="closeLayer('hotel')">
                <div class="btn-box">确 定</div>
            </div>
        </div>
    </div>
    <div class="guide-layer" v-if="isGuide=='T'">
        <div class="guide-box">
            <img :src="guideImg" @click="goGuide" class="guide-img" />
            <div class="iconfont iconshanchu1" @click.stop="closeGuide"></div>
            <div class="guide_tips" v-if="closeTips!='T'">
                <div class="tips" @click="tips = !tips"><i class="iconfont" :class="{'iconyixuanze':tips}"></i>不再提醒</div>
            </div>
        </div>
    </div>
    <!-- <guide-layer v-if="couponActivityConfig.isIndexPop&&couponActivityConfig.isIndexPop=='T'"></guide-layer> -->
    <guide-layer v-if="couponActivityConfig.isIndexPop=='T'" :couponActivityConfig="couponActivityConfig"></guide-layer>
    <receivedCouponLayer :coupon="curCoupon" @closeLayer="closeLayerCoupon" v-if="isReceivedCouponLayer"></receivedCouponLayer>
    <official-account></official-account>
    <!-- <receiveCoupons @showReceiveCoupons="showReceiveCoupons" pageName="index" @closeReceiveCoupons="closeReceiveCoupons" v-show="isShowReceiveCoupons"></receiveCoupons> -->
    <!-- <couponTrigger></couponTrigger> -->
</div>
</template>

<script>
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import {
    getStorage,
    setStorage
} from "@/utils/wxuser";
import Swiper from "swiper";
import bottomNav from "@/components/bottomNav";
import shopModule from "@/components/shopModule";
import bananerAdv from "@/components/bananerAdv";
import goodsList from "@/components/goodsList";
import goodsListSmall from "@/components/goodsListSmall";
import activityIndex from "@/components/index/activityIndex";
import price from "@/components/price";
import couponTrigger from "@/components/couponTrigger";
import receivedCouponLayer from '@/components/receivedCouponLayer';
import guideLayer from '@/components/guideLayer';
import receiveCoupons from '@/components/receiveCoupons';
import officialAccount from '@/components/officialAccount';

import {
    createUrl
} from "@/utils/index";
import gcTrack from "@/utils/gcTrack";
import {
    isWeChat
} from "@/utils/utils";
import {
    baseUrl
} from "@/utils/baseUrl";
var config = {};

export default {
    inject: ['reload'],
    data() {
        return {
            wxuser: getStorage("wxuser"),
            user: getStorage("user"),
            icon: "home",
            slides: {
                datas: [],
                link: [],
            },
            rushGoods: {},
            location: "index_middle_pic", //中间广告图
            goodsList: [],
            goodsDatas: {
                equipment: "desktop",
                firstResult: 0,
                pageSize: 20,
                orderCondition: "listOrder",
                orderDirection: "desc",
            },
            swiper: null,
            goodsType: [],
            goodsListTowColumn: getStorage("goodsListTowColumn") || "F", //是否限时两列商品
            groupList: [], //拼团列表
            coupons: [], //领券中心
            isAjax: true,
            isLoading: false,
            couponActivityConfig: {}, //券配置
            groupActivityConfig: {}, //团购配置
            templateId: "0", //首页模版id
            templateInfo: "", //获取首页模版数据
            initialization: false,
            guideImg: "", //弹窗广告图片
            guideLink: "", //弹窗广告链接
            isGuide: "F", //是否显示弹窗广告
            indexScrollPic: {},
            mainOpenid: "",
            shareUrl: "", //分享url
            isHotelGoods: 'T',
            areaInfo: [],
            hotelList: [],
            curChooseInfo: {
                city: '',
                hotelCode: '',
                cityDesc: '',
                hotelName: ''
            },
            isLayer: {
                isShowCity: false,
                isShowHotel: false
            },
            indexHotelGoods: 'F',
            totalRows: 0,
            tips: false,
            isReceivedCouponLayer: false,
            curCoupon: {},
            indexHotelCode:'',
            isShowReceiveCoupons:false,
        };
    },
    components: {
        bottomNav,
        shopModule,
        bananerAdv,
        goodsList,
        goodsListSmall,
        price,
        activityIndex,
        couponTrigger,
        receivedCouponLayer,
        guideLayer,
        receiveCoupons,
        officialAccount
    },

    filters: {
        wordLimit(val) {
            return val.substring(0, 4);
        },
    },

    watch: {
        $route: function (to, from) {
            if (to.path == from.path) {
                if (to.query.isGroup) {
                    config.hotelCode = 0
                    setStorage('config', config)
                } else if (to.query.belongHotelCode) {
                    config.hotelCode = to.query.belongHotelCode
                    setStorage('config', config)

                }
                this.reload();
            }
        },
    },
    methods: {
        showReceiveCoupons(){
            this.isShowReceiveCoupons = true;
        },
        closeReceiveCoupons(){
            this.isShowReceiveCoupons = false;
        },
        closeLayerCoupon(update) {
            if (update == 'T') {
                this.getCanReceivedList()
            }
            this.isReceivedCouponLayer = false
        },
        isShowLayer(val) {
            if (val == 'city') {
                this.isLayer.isShowCity = true
                if (this.curChooseInfo.city == '') {
                    this.curChooseInfo.city = this.areaInfo[0].code
                    this.curChooseInfo.cityDesc = this.areaInfo[0].descript
                }
            }
            if (val == 'hotel') {
                if (this.curChooseInfo.city == '') {
                    jAlert3('请先选择城市')
                    return false
                }
                this.isLayer.isShowHotel = true
                if (this.curChooseInfo.hotelCode == '') {
                    this.curChooseInfo.hotelCode = this.hotelList[0].code
                    this.curChooseInfo.hotelName = this.hotelList[0].descript
                }
            }
        },
        closeLayer(val) {
            if (val == 'city') {
                this.isLayer.isShowCity = false
                this.findHotelByCondition(this.curChooseInfo.city)
            }
            if (val == 'hotel') {
                this.isLayer.isShowHotel = false
                this.getGoodsList()
            }
        },
        chooseHotel(item) {
            this.curChooseInfo.hotelCode = item.code
            this.curChooseInfo.hotelName = item.descript

        },
        chooseCity(item) {
            this.curChooseInfo.city = item.code
            this.curChooseInfo.cityDesc = item.descript
        },
        findHotelByCondition(code) {
            var _this = this
            var opt = {
                hotelGroupCodes: config.hotelGroupCode,
                otaChannel: "WECHAT",
            }
            if (code && code != 'all') {
                opt.city = code
            }
            var reselect = false
            if (this.curChooseInfo.hotelCode != '') {
                reselect = true
            }
            this.curChooseInfo.hotelCode = ''
            this.curChooseInfo.hotelName = ''
            api.findHotelByCondition(opt).then(res => {
                if (res.result == 1) {
                    if (res.retVal.resultCode == 0) {
                        this.hotelList = []
                        this.hotelList[0] = {
                            descript: '全部门店',
                            code: 'all'
                        }
                        res.retVal.resultInfos.forEach((item, i) => {
                            this.hotelList.push(item)
                        })
                        if (reselect) {
                            this.chooseHotel(this.hotelList[0])
                            this.closeLayer('hotel')
                        }
                    }
                }
            })

        },
        getAreaInfo() {
            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                sortType: 'asc',

            };
            api.getAreaInfo(opt).then(res => {
                if (res.result == 1) {
                    this.areaInfo.push({
                        'code': 'all',
                        'descript': '全部区域'
                    })
                    for (var i in res.retVal) {
                        res.retVal[i].forEach((item) => {
                            this.areaInfo.push(item)
                        })
                    }

                } else {
                    jAlert3(res.msg);
                }
            })
        },
        goGroupHotel() {

            this.$router.push({
                path: "/index",
                query: {
                    isGroup: true
                }
            });
        },
        goCouponCenter() {

            this.$router.push({
                path: "/couponCenterNew",
            });
        },
        goCouponInfo(coupon) {
            this.$router.push({
                path: "/couponInfo",
                query: {
                    hotelCode: coupon.hotelCode || 0,
                    activityId: coupon.id,
                },
            });
        },

        chooseCoupon(coupon) {
            if (this.isLogin()) {
                if (coupon.ruleType == 'member') {
                    this.curCoupon = coupon
                    this.isReceivedCouponLayer = true
                } else {
                    if (coupon.canReceived !== "T") {
                        jAlert3("已经达到最大领取数");
                        return false;
                    }
                    this.receiveSCCoupon(coupon);
                }
               
            }
        },
        receiveSCCoupon(coupon) {
            if (!this.isAjax) {
                return false;
            }
            this.isAjax = false;
            var obj = {
                cardId: this.user.cardId,
                cardNo: this.user.cardNo,
                couponCode: coupon.couponCode,
                hotelGroupCode: config.hotelGroupCode,
                hotelGroupId: config.hotelGroupId,
                memberId: this.user.memberId,
                hotelCode: coupon.hotelCode,
                appid: config.appid,
                openid: this.wxuser.openid,
                couponType: coupon.couponType,
                cardLevel: this.user.cardLevel,
                mobile: this.user.mobile
            };
            obj.url = createUrl(obj)
            api.receiveSCCouponNew(obj).then((res) => {
                this.isAjax = true;
                if (res.result == 1) {
                    jAlert3("领取成功");
                    gcTrack.track("SC_ReceiveDiscount", {
                        discount_id: coupon.id,
                        discount_name: coupon.name,
                        discount_amount: coupon.presentValue,
                        discount_type: coupon.couponType
                    })
                    this.getCanReceivedList();
                } else {
                    jAlert3(res.msg);
                }
                console.log(res);
            });
        },
        getCanReceivedList() {
            if (!this.isAjax) {
                return false;
            }
            this.isAjax = false;
            api
                .getCanReceivedList({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelGroupId: config.hotelGroupId,
                    memberId: this.user.memberId || "",
                    hotelCode: config.hotelCode,
                    cardLevel: this.user.cardLevel || "",
                })
                .then((res) => {
                    if (res.result == 1) {
                        this.coupons = [];
                        res.retVal.forEach((n, i) => {
                            n.sta = "I";
                            n.isHide = true;
                            n.hexiaoRemark = n.couponDescribe;
                            if (n.ruleType == 'member') {
                                n.buttonText = '立即查看';
                            } else {
                                n.buttonText = '立即领取';
                            }
                            if (n.canReceived !== "T") {
                                n.disableBtn = true;
                                n.buttonText = "已领取";
                            }
                            if (n.vrEndDate && n.couponType == "coupon") {
                                n.validToDate = moment(n.vrEndDate).format("YYYY-MM-DD");
                            }
                            if (n.couponType == "RF") {
                                n.presentValue = (Number(n.presentValue) * 10).toFixed(0);
                            }
                        });
                        this.coupons = res.retVal;
                    }
                    this.isAjax = true;
                });
        },
        findShopGroupList() {
            this.groupList = []
            api
                .findShopGroupList({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelCode: config.hotelCode,
                    shopChannel: "group",
                    equipment: "desktop",
                    firstResult: 0,
                    pageSize: 100,
                    channel: config.channel,
                    appid: config.appid,
                })
                .then((res) => {
                    if (res.result == 1) {
                        if (res.retVal.datas.length > 0) {
                            res.retVal.datas.forEach((item) => {
                                if (item.groupHeadImgUrl) {
                                    this.$set(item, "headimg", item.groupHeadImgUrl.split(","));
                                }
                                item.goodsCity = '爆款拼团'
                                item.logo = item.goodsLogo
                                item.stock = item.groupStock
                                item.name = item.goodsName
                                item.price = item.groupPrice
                                this.groupList.push(item);
                            });
                            // this.$nextTick(() => {
                            //   this.initSwiper3();
                            // });
                        }
                    }
                });
        },
        goGroupList() {

            this.$router.push({
                path: "/groupBookList",
            });
        },
        goGroup(goods, i) {
            var data = {
                banner_belong_area: '拼团',
                banner_type: '商品',
                banner_name: goods.goodsName,
                banner_id: goods.id,
                banner_rank: i + 1
            }
            gcTrack.track("SC_HomeOoperationClick", data)
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: goods.id,
                    productType: "group",
                },
            });
        },
        refresh() {

            this.shopIndePage(() => {
                this.batchQueryShopConfig(() => {
                    this.findShopGroupList();
                    if (this.user && this.user.memberId) {
                        if(this.couponActivityConfig.isIndex&&this.couponActivityConfig.isIndex=='T'){
                            this.getCanReceivedList();
                        }
                    }
                });
                this.getScrollPic("F");
                this.getSecondRush();
                this.getGoodsList(true);
                this.goodsTypeIndex();
            });
        },
        getmore(item) {
            this.$router.push({
                path: "typeList",
                query: {
                    typeId: item.id,
                },
            });
        },
        goodsTypeIndex() {
            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                channel: config.channel,
                appid: config.appid,
                equipment: "desktop",
            };
            if (this.$route.query.belongHotelCode) {
                opt.belongHotelCode = config.hotelCode
            }
            if (this.user && this.user.memberId) {
                this.getCurrentCard();
                var chuzhiIndex = getStorage("cardIndex") || 0;
                opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                if(getStorage('levelCode')){
                    opt.cardCode = getStorage('levelCode')
                }
            }
          
            api.goodsTypeIndex(opt).then((res) => {
                if (res.result == 1) {
                    this.goodsType = res.retVal;
                } else {
                    jAlert3(res.msg);
                }
            });
        },
        goFlashGoods(item, i) {
            var data = {
                banner_belong_area: '限时抢购',
                banner_type: '商品',
                banner_name: item.goodsName,
                banner_id: item.id,
                banner_rank: i + 1
            }
            gcTrack.track("SC_HomeOoperationClick", data)
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: item.id,
                    productType: "flash",
                    flashTimeSlotRelitionId: item.relationId,
                },
            });
        },
        goType() {
            let query ={}
            if(this.curChooseInfo.hotelCode){
                query.hotelCode = this.curChooseInfo.hotelCode
                query.city = this.curChooseInfo.city
            }
            this.$router.push({
                path: "/typeList",
                query:query

            });
        },
        goTypeList() {

            this.$router.push({
                path: "/typeList",
                query: {
                    sortType: 3
                },
            });
        },
        goShopFlashSale(item) {
            this.$router.push({
                path: "/shopFlashSale",
                query:{
                    id:item[0].configId
                }
            });
        },
        initSwiper() {
            this.swiper = new Swiper(".swiper-container", {
                autoplay: true,
                paginationClickable: true,
                autoplayDisableOnInteraction: true, // 处理手动滑动后，继续自动滑动
                loop: this.slides.datas.length > 1,
                observer: true,
                observeParents: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });
        },
        initSwiper2() {
            var swiper2 = new Swiper("#goodsList", {
                autoplay: false,
                autoplayDisableOnInteraction: false, // 处理手动滑动后，继续自动滑动
                loop: false,
                observer: true,
                observeParents: true,
                slidesPerView: "auto",
            });
        },
        initSwiper3() {
            var swiper3 = new Swiper("#groupList", {
                autoplay: false,
                autoplayDisableOnInteraction: false, // 处理手动滑动后，继续自动滑动
                loop: false,
                observer: true,
                observeParents: true,
                slidesPerView: "auto",
            });
        },

        getSecondRush() {
            api
                .secondRush({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelCode: config.hotelCode,
                    channel: config.channel,
                    appid: config.appid,
                    shopChannel: "flash",
                })
                .then((res) => {
                    if (res.result == 1) {
                        res.retVal.forEach(item => {
                            item.goodsCity = '限时抢购'
                            item.logo = item.flashLogo
                            item.stock = item.number
                            item.name = item.goodsName
                            if(!this.rushGoods[item.configId]){
                                this.rushGoods[item.configId] = []
                            }
                            this.rushGoods[item.configId].push(item)
                        })
                        
                    }
                });
        },
        goGoodsDetail(id) {
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: id,
                },
            });
        },
        goSeacher() {
            this.$router.push({
                path: "/searchIndex",
            });
        },
        goPage(url, index) {
            if (url) {
                var data = {
                    banner_belong_area: '首页轮播图',
                    banner_type: this.indexScrollPic.location,
                    banner_name: "",
                    banner_id: this.indexScrollPic.id,
                    banner_rank: index + 1
                }
                gcTrack.track("SC_HomeOoperationClick", data)
                window.location.href = this.wrapperUrl(url);
            }
        },
        getGuide() {

            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                location: "index_layer",
                linkType: config.linkType,
                hotelCode: config.hotelCode,
                appid: config.appid
            };
            api.getScrollPic(opt).then((res) => {
                if (res.result == 1) {
                    if (res.retVal.picUrl) {
                        this.guideImg = res.retVal.picUrl.split(",")[0];
                        this.guideLink = res.retVal.link.split(",")[0];
                        if (getStorage("isGuide") == this.guideImg) {
                            return false;
                        }
                        if (this.guideImg != "") {
                            if (res.retVal.userRegisterTime) {
                                if (this.user.createDatetime && moment(res.retVal.userRegisterTime).format("x") < moment(this.user.createDatetime).format("x")) {
                                    this.isGuide = "T";
                                }
                            } else {
                                this.isGuide = "T";
                            }

                        }
                    }
                } else {
                    jAlert3(res.msg);
                }
            });
        },
        goGuide() {
            if (this.tips) {
                setStorage("isGuide", this.guideImg);
            }
            window.location.href = this.guideLink
        },
        closeGuide() {
            if (this.tips) {
                setStorage("isGuide", this.guideImg);
            }
            this.isGuide = "F";
        },
        getScrollPic(isInit) {
            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                location: "index_picture",
                linkType: config.linkType,
                appid: config.appid
            };
            if (opt.hotelCode != 0) {
                opt.location = "hotel_index_picture";
            }
            this.slides = {
                datas: [],
                link: [],
            };
            api.getScrollPic(opt).then((res) => {
                if (res.result == 1) {
                    if (res.retVal.picUrl) {
                        this.indexScrollPic = res.retVal
                        this.slides.datas = res.retVal.picUrl.split(",");
                        this.slides.link = res.retVal.link.split(",");
                        var link = this.slides.link
                        console.log(link)
                        link.forEach((item, i) => {
                            var cardLevel = this.getQueryVariable(item, 'cardLevel')
                            if (cardLevel && this.scrollType != '3') {
                                var allow = false
                                var cardLevels = cardLevel.split('|')

                                cardLevels.forEach((item) => {
                                    if (this.user.cardLevel && item == this.user.cardLevel) {
                                        allow = true
                                    }
                                })
                                if (!allow) {
                                    this.slides.link.splice(i, 1)
                                    this.slides.datas.splice(i, 1)
                                }
                            }
                        })
                        if (isInit == "F") {
                            this.swiper.update();
                        } else {
                            this.$nextTick(() => {
                                this.initSwiper();
                            });
                        }
                    }
                } else {
                    jAlert3(res.msg);
                }
            });
        },
        batchQueryShopConfig(cb) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                configItem: "index_title,couponActivityConfig,groupActivityConfig,indexHotelGoods",
            };
            api.batchQueryShopConfig(opt).then((res) => {
                if (res.result == 1) {
                    var title = '商城'
                    res.retVal.forEach((item) => {
                        if (item.configItem == "index_title") {
                            if (item.itemValue && item.itemValue != "") {
                                title = item.itemValue;
                            }
                        }
                        if (item.configItem == "couponActivityConfig") {
                            this.couponActivityConfig = JSON.parse(item.itemValue);
                        }
                        if (item.configItem == "groupActivityConfig") {
                            this.groupActivityConfig = JSON.parse(item.itemValue);
                        }
                        if (item.configItem == 'indexHotelGoods') {
                            if (item.itemValue && config.hotelCode == '0') {
                                this.indexHotelGoods = item.itemValue
                            }

                        }
                    });
                    document.title = title
                    cb && cb();
                }
            });
        },
        getGoodsList(fresh) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                channel: config.channel,
                appid: config.appid,
            };

            this.user = getStorage("user");
            if (this.user && this.user.memberId) {
                this.getCurrentCard();
                var chuzhiIndex = getStorage("cardIndex") || 0;
                opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            }
            if (this.$route.query.belongHotelCode) {
                opt.belongHotelCode = config.hotelCode
            }
            if (this.indexHotelGoods != 'T') {
                opt.isHotRecommend = 'T'
            } else {
                if (this.curChooseInfo.city != '') {
                    if (this.curChooseInfo.hotelCode == 'all') {
                        var hotelCode = []
                        this.hotelList.forEach((item, i) => {
                            if (i !== 0) {
                                hotelCode.push(item.code)
                            }
                        })
                        opt.hotelCode = 0
                        opt.cityHotelCode = hotelCode.join(',')
                    } else {

                        opt.belongHotelCode = this.curChooseInfo.hotelCode
                    }
                }
            }
            if(getStorage('levelCode')){
                opt.cardCode = getStorage('levelCode')
            }
            opt = Object.assign(opt, this.goodsDatas);
            api.listGoods(opt).then((res) => {
                if (res.result == 1) {
                    this.goodsList = res.retVal.datas;
                    this.totalRows = res.retVal.totalRows
                    // this.initSwiper2();
                } else {
                    jAlert3(res.msg);
                }
                if (fresh) {
                    this.isLoading = false;
                }
            });
        },
        shopIndePage(cb) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                channel: config.channel,
                appid: config.appid
            };
            api
                .shopIndePage(opt)
                .then((res) => {
                    if (res.result == 1) {
                        this.templateId = '0'
                        if (res.retVal[0] && res.retVal.length && res.retVal.length > 0) {
                            res.retVal.forEach(item => {

                                if (this.$route.query.previewId) {
                                    if (item.id == this.$route.query.previewId) {
                                        this.templateId = item.templateId
                                        this.templateInfo = item.templateInfo
                                        this.indexHotelCode =item.hotelCode


                                    }
                                } else {
                                    if (item.isDefault == 'T') {
                                        this.templateId = item.templateId
                                        this.templateInfo = item.templateInfo
                                        this.indexHotelCode =item.hotelCode

                                    }
                                }

                            })
                            if (this.templateId == '0') {
                                cb && cb();
                            }
                            this.initialization = true
                        } else {
                            cb && cb();
                        }
                        this.initialization = true
                    } else {
                        this.initialization = true;
                        cb && cb();
                    }
                    this.getGuide();
                })
                .catch((err) => {
                    this.initialization = true;
                    cb && cb();
                });
        },
        myDistributionCenter(cb) {
            var opt = {
                openId: this.wxuser.openid,
                memberId: this.user.memberId,
                componentAppid: config.componentAppid,
                hotelGroupId: config.hotelGroupId,
                appid: config.appid,
                hotelGroupCode: config.hotelGroupCode,
            };
            api.isDistributor(opt).then((res) => {
                var shareUrl = `${window.location.origin}${baseUrl}#`;
                var query = this.$route.query;
                var path = "";

                for (var i in query) {
                    if (
                        i != "distributorOpenId" &&
                        i != "distributorId" &&
                        i != "openId" &&
                        i != "shareId" &&
                        i != "distributorOpenIdDis"
                    ) {
                        if (path == "") {
                            path = "/index&" + i + "=" + query[i];
                        } else {
                            path += "&" + i + "=" + query[i];
                        }
                    }
                }
                if (path == '') {
                    path = "/index"
                }
                if (this.mainOpenid != "") {
                    if (typeof this.mainOpenid == "object") {
                        this.mainOpenid.forEach((item) => {
                            if (item != "") {
                                this.mainOpenid = item;
                                setStorage('mainOpenid', this.mainOpenid)
                            }
                        });
                    }
                    path += "&distributorOpenId=" + this.mainOpenid
                    path += "&distributorOpenIdDis=" + this.wxuser.openid;
                } else {
                    path += "&distributorOpenId=" + this.wxuser.openid
                }
                if (res.result == 1) {
                    if (res.retVal && res.retVal.id) {
                        path += "&distributorId=" + res.retVal.id

                    }
                }
                this.shareUrl = shareUrl + path.replace('&', '?')
                console.log(this.shareUrl)
                cb && cb();
            });
        },
        getStorageMainOpenid() {
            if (getStorage("mainOpenid")) {
                this.mainOpenid = getStorage("mainOpenid");
            }
        },

    },
    created() {
        config = getStorage("config");
    },
    mounted() {
        this.refreshMemberInfo()
        this.getStorageMainOpenid()
        
        this.shopIndePage(() => {
            if (isWeChat()) {
                this.myDistributionCenter(() => {
                    this.wechatShare({
                        code: "public",
                        shareUrl: this.shareUrl,
                    });
                })
            }
            this.batchQueryShopConfig(() => {
                if (this.indexHotelGoods == 'T') {
                    this.getAreaInfo()
                    this.findHotelByCondition()
                }
                this.getGoodsList();
                this.findShopGroupList();
                if (this.user && this.user.memberId) {
                    if(this.couponActivityConfig.isIndex&&this.couponActivityConfig.isIndex=='T'){
                        this.getCanReceivedList();
                    }
                    
                }
            });
            this.getScrollPic();
            this.getSecondRush();

            this.goodsTypeIndex();
        });

    },
    computed: {},
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.index-ui {
    width: 100%;
    min-height: 100vh;
    background-size: 100vw 100vh;
    background-attachment: fixed;
    padding-bottom: 50px;

    background: #f6f6f6;
    overflow: hidden;
    

    .scroller {
        overflow: hidden;
    }

    .swiper-container {
        width: 100%;
        height: 6.666667rem;
        position: relative;

        .swiper-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            z-index: 1;

            .swiper-slide {
                width: 100%;
                height: 100%;
                transform: translate3d(0, 0, 0);

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .search {
            position: absolute;
            display: flex;
            height: 0.933333rem;
            align-items: center;
            justify-content: center;
            bottom: 0.666667rem;
            left: 5%;
            font-size: 15px;
            width: 90%;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 0.533333rem;
            z-index: 9;
            color: #ffffff;

            .iconsousuo {
                font-size: 15px;
                margin-right: 0.133333rem;
            }

            p {
                font-size: 15px;
            }
        }
    }

    .container-box {
        margin-top: 0.533333rem;

        .couponListBox {
            // padding-top: 0.213333rem;

            .couponListActivity {
                padding: 0 0.266666rem 0;
                box-sizing: border-box;

                .couponActivity {
                    display: inline-block;
                    width: 4.52rem;
                    height: 1.466667rem;
                    border-radius: 3px;
                    overflow: hidden;
                    box-sizing: border-box;
                    margin: 0.266667rem 0.106667rem 0;
                    box-shadow: 0 6px 12px 0 rgba(74, 112, 196, 0.06);

                    .couponActivityInner {
                        height: 100%;
                        width: 100%;
                        display: flex;
                        background: #fff;
                        box-sizing: border-box;

                        .leftPart {
                            width: 2.773333rem;
                            height: 100%;
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            &::after {
                                content: "";
                                position: absolute;
                                right: -3px;
                                top: 8px;
                                width: 6px;
                                height: calc(100% - 8px);
                                background: radial-gradient(#f6f6f6 0,
                                        #f6f6f6 2px,
                                        transparent 2px);
                                background-size: 6px 6px;
                                background-position: 0 -1px;
                            }
                        }

                        .rightPart {
                            position: relative;
                            flex: 1;
                            z-index: 2;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;

                            &::before {
                                content: "";
                                position: absolute;

                                width: 8px;
                                height: 8px;
                                background: #f6f6f6;
                                left: -4px;
                                top: -4px;
                                border-radius: 50%;
                            }

                            &::after {
                                content: "";
                                position: absolute;

                                width: 8px;
                                height: 8px;
                                background: #f6f6f6;
                                left: -4px;
                                bottom: -4px;

                                border-radius: 50%;
                            }

                            .price {
                                font-size: 8px;
                                color: @color-theme;
                                font-weight: bold;
                                margin-bottom: 3px;
                                .textHidden();

                                em {
                                    display: inline-block;
                                    font-size: 8px;
                                }
                            }

                            .subTitle {
                                font-size: 8px;
                                color: @color-theme;
                                font-weight: bold;
                                .textHidden();
                            }

                            .getBtn {
                                height: 0.426667rem;
                                min-width: 1.066667rem;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: @color-theme;
                                border-radius: 3px;
                                font-size: 8px;
                                color: #ffffff;
                                margin-top: 0.133333rem;

                                &.disable {
                                    background: #cccccc;
                                }
                            }
                        }
                    }
                }

                &.couponListActivity-scroll {
                    white-space: nowrap;
                    overflow-x: scroll;
                    overflow-y: hidden;

                    .couponActivity {
                        width: 4rem;
                        height: 1.333333rem;

                        .leftPart {
                            width: 2.533333rem;
                        }
                    }
                }
            }
        }

        .goods-wrap-two {
            padding: 0 0.293333rem 0.266667rem;
            width: 100%;
            box-sizing: border-box;
            flex-wrap: wrap;
            justify-content: space-between;
            display: flex;

            &.goods-wrap-scroll {
                width: 100%;
                box-sizing: border-box;
                white-space: nowrap;
                display: flex;
                height: 4.933333rem;

                .goods-box {
                    width: 4rem;

                    .goods-img {
                        height: 2.666667rem;
                    }
                }
            }

            .goods-box {
                display: inline-block;
                width: 3.12rem;
                margin: 0 0.106667rem 0.266667rem;
                background: #fff;
                // box-shadow: @box-shadow;

                .goods-img {
                    height: 2.96rem;
                    width: 100%;

                    position: relative;

                    .logo {
                        width: 100%;
                        height: 100%;
                        border-radius: 6px;
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 3.84rem;
                        margin-left: -1.92rem;
                        height: 0.48rem;
                        .textHidden();

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.47988rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.47988rem;
                            text-align: center;
                            padding: 0 0.266667rem;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            z-index: 1;
                            left: 50%;
                            margin-left: -1.6rem;
                            width: 3.2rem;
                            background: rgba(0, 109, 224, 0.6);
                            height: 0.48rem;
                            box-sizing: border-box;
                            border-radius: 8px 8px 0 0;
                            transform: perspective(10px) scale(1.1, 1.3) rotateX(5deg);
                        }
                    }
                }

                .goods-info {
                    position: relative;
                    padding: 0.106667rem 0.32rem 0.266667rem;

                    .goods-to-hotel {
                        width: 100%;
                        font-family: PingFangSC-Regular;
                        font-size: 11px;
                        line-height: 0.56rem;
                        color: #9398a1;
                        .textHidden();
                    }

                    .goods-name {
                        width: 100%;
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        font-weight: bold;
                        color: #111;
                        margin-top: 10rpx;

                        p {
                            overflow: hidden;
                            height: 0.533333rem;
                            line-height: 0.533333rem;
                            word-break: break-all;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            white-space: normal;
                        }
                    }

                    .goods-price {
                        display: flex;
                        align-items: center;
                        margin-top: 0.133333rem;

                        b {
                            font-size: 15px;
                            color: @color-price;
                            font-weight: bold;
                            margin-right: 0.186667rem;
                        }

                        i {
                            margin-top: 0.053333rem;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            // color: @color-noChoose;
                            text-decoration: line-through;
                        }
                    }
                }
            }
        }

        // .group-box {
        //   margin-top: 0.48rem;
        //   .goodsBox {
        //     .goodList {
        //       //display:flex;
        //       .good {
        //         height: 5.173333rem;
        //         background: rgba(255, 255, 255, 1);
        //         box-shadow: 0px 6px 12px 0px rgba(74, 112, 196, 0.06);
        //         border-radius: 6px;
        //         width: 4.453333rem;
        //         box-sizing: border-box;
        //         display: inline-block;
        //         vertical-align: top;
        //         margin-bottom: 0.266667rem;

        //         &.bigPicMode {
        //           width: 100%;
        //           height: 7.306667rem;

        //           .topBox {
        //             height: 5.2rem;

        //             img {
        //               width: 100%;
        //               height: 100%;
        //             }
        //           }
        //         }

        //         &:nth-of-type(even) {
        //           margin-left: 0.213333rem;
        //         }

        //         .topBox {
        //           height: 2.96rem;
        //           width: 100%;
        //           position: relative;

        //           img {
        //             border-top-left-radius: 6px;
        //             border-top-right-radius: 6px;
        //             position: absolute;
        //             top: 0px;
        //             left: 0px;
        //             width: 100%;
        //             height: 2.96rem;
        //           }

        //           .showBanner {
        //             height: 0.533333rem;
        //             display: flex;
        //             align-items: center;
        //             padding-left: 0.133333rem;
        //             background: rgba(232, 55, 74, 1);
        //             position: absolute;
        //             bottom: 0;
        //             left: 0;
        //             width: 100%;
        //             box-sizing: border-box;
        //             color: #fff;
        //             font-size: 11px;

        //             &.disabled {
        //               background: rgba(177, 177, 177, 1);
        //             }
        //           }
        //         }

        //         .bottomBox {
        //           height: 2.213333rem;
        //           padding: 0.133333rem 0.266667rem;
        //           box-sizing: border-box;
        //           position: relative;

        //           .hotelName {
        //             font-size: 11px;
        //             color: #9398a1;
        //             line-height: 0.426667rem;
        //             height: 0.426667rem;
        //             .textHidden();
        //           }

        //           .name {
        //             font-size: 14px;
        //             color: 12px;
        //             margin-bottom: 0.133333rem;
        //             .textHidden();
        //           }

        //           .money {
        //             color: #e76434;
        //             font-size: 15px;
        //             margin-bottom: 0.133333rem;
        //             font-weight: bold;
        //             .textHidden();

        //             span {
        //               color: #d7dade;
        //               font-size: 12px;
        //               text-decoration: line-through;
        //               margin-left: 0.266667rem;
        //             }
        //           }

        //           .goodsFooter {
        //             margin-top: 0.133333rem;
        //             display: flex;
        //             justify-content: space-between;
        //             align-items: center;

        //             .goodsCredit {
        //               font-size: 0.32rem;
        //               color: @color-theme;
        //             }

        //             .payBtn {
        //               height: 0.64rem;
        //               width: 1.6rem;
        //               background: linear-gradient(
        //                 179deg,
        //                 rgba(60, 138, 255, 1) 0%,
        //                 rgba(31, 79, 181, 1) 100%
        //               );
        //               border-radius: 3px;
        //               position: absolute;
        //               bottom: 0.266667rem;
        //               right: 0.266667rem;
        //               font-size: 10px;
        //               color: #fff;
        //               line-height: 0.64rem;
        //               text-align: center;

        //               &.disabled {
        //                 background: rgba(215, 218, 222, 1);
        //               }
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
    }

    .flash-list,
    .container {
        .title {
            padding: 0 0.48rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tl {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }

            .more {
                font-size: 12px;
                color: @color-theme;
                display: flex;
                align-items: center;
 

                &::after {
                    position: static;
                    margin: -2px 0 0 0;
                    border-right: 1px solid #666;
                    border-top: 1px solid #666;
                }

                i {
                    font-size: 12px;
                    color: @color-theme;
                }
            }

            .arrow::after {
                width: 0.16rem;
                height: 0.16rem;
                margin-top: 0;
            }
        }
    }

    .flash-list {
        margin-top: 0.64rem;

        .goods-list-box {
            position: relative;
            white-space: nowrap;
            margin-top: 0.266667rem;

            .box {
                width: 4.106667rem !important;
                padding: 0 0 0.266667rem 0;
                background: #fff;
                display: inline-block;
                border-radius: 0.213333rem;
                margin-left: 0.373333rem;
                box-sizing: border-box;
                overflow: hidden;

                .img-box {
                    width: 100%;
                    overflow: hidden;
                    border-radius: 0.213333rem;
                    height: 2.666667rem;
                    border: 2px solid #fff;
                    position: relative;

                    .label {
                        position: absolute;
                        z-index: 2;
                        color: #fff;
                        height: 0.64rem;
                        line-height: 0.64rem;
                        text-align: center;
                        padding: 0 0.266667rem;

                        &::after {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: -1;
                            width: 100%;
                            height: 100%;
                            background: @color-theme;
                            opacity: 0.6;
                            border-radius: 0.213333rem 0.213333rem 0.213333rem 0px;
                        }

                        span {
                            min-width: 1rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-left: 0.2rem;
                            height: 0.64rem;
                            line-height: 0.64rem;
                            white-space: nowrap;
                            box-sizing: border-box;
                            overflow: hidden;
                            text-align: center;
                        }
                    }

                    .img {
                        width: 100%;
                        height: 100%;

                        border-radius: 0.213333rem;
                    }

                    .bg {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        border-radius: 0.213333rem;
                        left: 0;
                        top: 0;
                    }
                }

                .goods-content {
                    padding: 0 0.266667rem;

                    .goods-name {
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 0.666667rem;
                        height: 0.666667rem;
                        overflow: hidden;
                        color: #333333;
                        white-space: normal;
                    }

                    .desc {
                        margin-top: 0.133333rem;
                        font-size: 14px;
                        color: #999999;
                        height: 0.48rem;
                        width: 100%;
                        white-space: normal;
                        line-height: 0.48rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }

                    .price {
                        justify-content: center;
                    }

                    .btn {
                        display: flex;
                        justify-content: center;
                        margin-top: 0.15rem;

                        img {
                            width: 2.533333rem;
                            height: 0.48rem;
                        }
                    }
                }
            }

            .no-stock {
                border-radius: 0.213333rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 99;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .group-tips {
        display: flex;
        justify-content: center;
        padding: 0.8rem 0;
        font-size: 12px;
        color: #999999;

        b {
            font-size: 12px;
            color: @color-theme;
            text-decoration: underline;
            display: inline-block;
        }
    }

    .bananer-adv {
        margin-top: 0.533333rem;
    }

    .content-box {
        margin-top: 0.533333rem;

        .option {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 0.18662rem;
            border-bottom: 1px solid #ECF0F2;
            padding-bottom: 0.16rem;
            margin: 0 0.4rem;

            .option-boxs {
                display: flex;
                flex: 1;

                .option-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 0.21328rem;
                    box-sizing: border-box;
                    height: 1.25302rem;
                    padding: 0.21328rem 0.266667rem 0.15996rem 0.21328rem;
                    border-radius: 0.1333rem;
                    border: 1px solid #ECF0F2;
                    background: #fff;
                    flex: 1;

                    &.option-box-flex {
                        margin: 0;
                    }

                    &.option-select {
                        border: 0;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                        padding-left: 0.18662rem;
                        position: relative;
                        padding-right: 0.3999rem;
                        min-width: none;
                        color: #2F3740;
                        font-weight: bold;
                        font-size: 14px;

                        i {
                            color: #aaa;
                            margin-top: 0.02666rem;
                            font-size: 13px;
                            margin-right: 0.1333rem;
                        }
                    }

                    .option-box-top {
                        display: flex;
                        align-items: center;
                        color: #2F3740;
                        font-weight: bold;
                        font-size: 14px;

                        i {
                            color: #aaa;
                            margin-top: 0.02666rem;
                            font-size: 12px;
                            margin-right: 0.1333rem;
                        }

                        image {

                            height: 0.3999rem;
                            width: 0.3999rem;
                            margin-right: 0.05332rem;
                        }

                        .choose {
                            position: relative;

                            &:after {
                                content: '';
                                position: absolute;
                                right: -0.3999rem;
                                top: 0;
                                border-right: 0.02666rem solid #aaa;
                                border-bottom: 0.02666rem solid #aaa;
                                width: 0.18662rem;
                                height: 0.18662rem;
                                transform: rotate(45deg);
                            }
                        }
                    }

                    .num {

                        display: flex;
                        margin-left: 0.45322rem;
                        font-size: 12px;
                        line-height: 0.45322rem;

                        b {
                            color: @color-theme;
                            font-weight: bold;
                            font-size: 12px;

                        }
                    }

                }
            }

            .goods-num {
                font-size: 11px;
                color: #666666;
                min-width: 1.75956rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-end;

                p {
                    min-width: 1.75956rem;
                    display: flex;
                    justify-content: flex-end;

                    b {
                        color: @color-theme;
                        font-weight: bold;
                        margin-right: 0.1333rem;
                    }
                }
            }
        }

        .hotel_goods_list {
            margin-top: -0.266667rem;
        }

        .more-goods {
            display: flex;
            margin-top: 0.266667rem;
            justify-content: center;

            .btn {
                border-radius: 0.4256rem;
                border: 1px solid #F2F2F2;
                display: flex;
                height: 0.8512rem;
                padding: 0 0.5586rem;
                background: #fff;
                justify-content: center;
                align-items: center;
                color: @color-theme;
                font-size: 12px;

                i {
                    color: @color-theme;
                    font-size: 10px;
                    margin-left: 0.1064rem;
                }
            }
        }
    }

    .goodsType {

        .title {
            padding: 0.266667rem 0.48rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tl {
                font-size: 16px;
                color: #333333;
                line-height: 0.586667rem;
            }

            .more {
                font-size: 12px;
                color: @color-theme;
                display: flex;
                align-items: center;
                white-space: nowrap;

                i {
                    font-size: 12px;
                    color: @color-theme;
                }
            }

            .arrow::after {
                width: 0.16rem;
                height: 0.16rem;
                margin-top: 0;
            }
        }

        .goodsListForType {
            margin-top: -0.266667rem;
        }

        .goodsTypeBg {
            width: 100%;

            img {
                width: 100%;
            }
        }
    }

    .goodsListHot {
        margin-top: 0.64rem;

        .title {
            padding: 0 0.48rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tl {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }

            .more {
                font-size: 12px;
                color: @color-theme;
                display: flex;
                align-items: center;

                i {
                    font-size: 12px;
                    color: @color-theme;
                }
            }

            .arrow::after {
                width: 0.16rem;
                height: 0.16rem;
                margin-top: 0;
            }
        }
    }

}

.choose-layer {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: -500%;
    opacity: 0;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity .3s;

    &.choose-layer-active {
        opacity: 1;
        top: 0;
    }

    .choose-layer-box {
        padding: 0 0.4522rem 0;
        box-sizing: border-box;
        background: rgba(249, 250, 251, 1);
        border-radius: 0.266rem;
        width: 9.1238rem;
        position: absolute;
        top: 50%;
        left: 50%;

        max-height: 70%;
        overflow-y: scroll;
        transform: translate(-50%, -50%);

        .tl {
            position: sticky;
            top: 0;
            padding-top: 0.2128rem;
            background: rgba(249, 250, 251, 1);
            font-size: 12px;
            color: #666666;
            line-height: 0.798rem;
            display: flex;
            justify-content: center;

            b {
                color: @color-theme;
            }
        }

        .list {

            display: flex;
            min-height: 4.655rem;
            flex-wrap: wrap;
            padding: 0.1862rem;
            max-height: 75%;
            background: #f9fafb;
            align-content: flex-start;
            justify-content: space-between;

            .item {
                position: relative;
                width: 3.6708rem;
                height: 1.33rem;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 0.399rem 0px rgba(24, 32, 111, 0.05);
                border-radius: 0.1596rem;
                display: flex;
                align-items: center;
                padding-left: 0.3192rem;
                color: #111111;
                font-weight: bold;
                font-size: 14px;
                margin: 0.2128rem 0;
                box-sizing: border-box;

                &.big-item {
                    width: 100%;
                    margin: 0.1064rem 0;
                }

                i.iconweizhi,
                i.iconjiudianweixuanzhong {
                    color: @color-theme;
                    font-size: 12px;
                    margin-right: 0.1596rem;
                }

                i.icongouhao {
                    display: none;
                    position: absolute;
                    top: -0.0266rem;
                    right: -0.0266rem;
                    width: 0.7448rem;

                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 9px;
                    height: 0.532rem;
                    background: @color-theme;
                    border-top-right-radius: 0.1596rem;
                    border-bottom-left-radius: 0.1596rem;
                }

                &.active {
                    border: 1px solid @color-theme;
                    box-shadow: none;

                    i.icongouhao {
                        display: flex;
                    }
                }

            }
        }

        .btn {
            position: sticky;
            bottom: 0;
            padding-bottom: 0.6384rem;
            margin-top: 0.4256rem;
            width: 100%;
            height: 1.1172rem;
            background: rgba(249, 250, 251, 1);
            box-sizing: content-box;

            .btn-box {
                width: 100%;
                height: 1.1172rem;
                background: @color-theme;
                border-radius: 0.1596rem;
                height: 1.1172rem;
                display: flex;
                justify-content: center;
                align-items: center;

                color: #FFFFFF;

                font-size: 14px;
            }
        }
    }
}

.guide-layer {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.7);

    .guide-box {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        align-items: center;
        flex-direction: column;
        transform: translate(-50%, -50%);

        .guide-img {
            width: 7.733333rem;
        }

        .guide_tips {
            color: #fff;
            margin-top: 0.8rem;
            display: flex;
            justify-content: center;

            .tips {
                display: flex;
                align-items: center;
                font-size: 14px;

                i {
                    display: flex;
                    align-items: center;
                    border: 1px solid #fff;
                    width: 16px;
                    height: 16px;
                    font-size: 16px;
                    box-sizing: border-box;
                    color: #fff;
                    margin-right: 0.186667rem;
                    border-radius: 2px;

                    &.iconyixuanze {
                        border: 0;
                    }
                }
            }
        }

        .iconshanchu1 {
            position: absolute;
            top: -15px;
            right: -15px;
            color: #fff;
            font-size: 30px;

        }
    }
}
</style><style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.index-ui {
    .swiper-pagination {
        background: none;

        .swiper-pagination-bullet {
            width: 0.16rem !important;
            height: 2px;
            background: #fff;
            border-radius: 1px;
            opacity: 1;
        }

        .swiper-pagination-bullet-active {
            background: @color-theme;
        }
    }

    ._v-content {
        padding-bottom: 0.133333rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue